import { each } from 'lodash';
import {
  GOD_TABLE_SAVE_TABLE_STATES,
  GOD_TABLE_UPDATE_CUSTOM_META_DATA,
  GOD_TABLE_DELETE_CUSTOM_META_DATA,
  GOD_TABLE_FETCH_COLUMN_DATA,
  GOD_TABLE_RESET_TABLE_STATES,
  GOD_TABLE_REQUEST_EDIT_COLUMN,
  GOD_TABLE_REQUEST_DELETE_COLUMN,
  GOD_TABLE_REQUEST_RESET_COLUMNS,
  GOD_TABLE_REQUEST_EDIT_CUSTOM_META,
} from './actions';

// Initial State
const initialState = {
  states: {
  }, // indexed  by id
  columnData: {

  }, // indexed by object id
  editingColumn: {
    tableId: null,
    column: null,
  },
  deletingColumn: {
    tableId: null,
    column: null,
  },
  resetingTableId: null,
  editingMeta: null,
};


const GodTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case GOD_TABLE_SAVE_TABLE_STATES: {
      const {
        authId, organizationId, tableId, config,
      } = action;
      const { states } = state;
      return {
        ...state,
        states: {
          ...states,
          [`${organizationId}::${authId}::${tableId}`]: config,
        },
      };
    }
    case GOD_TABLE_RESET_TABLE_STATES: {
      return {
        ...state,
        states: {},
      };
    }
    case GOD_TABLE_UPDATE_CUSTOM_META_DATA: {
      const { meta, columnId } = action;
      const { columnData } = state;
      const newColumnData = { ...columnData };
      const objectId = meta.object_id;
      // const metaId = meta.meta__id;
      if (!newColumnData[objectId]) {
        newColumnData[objectId] = {};
      }
      newColumnData[objectId][columnId] = meta.value;
      return {
        ...state,
        columnData: newColumnData,
      };
    }
    case GOD_TABLE_DELETE_CUSTOM_META_DATA: {
      // const { metaId, objectId, columnId } = action;
      const { objectId, columnId } = action;
      const { columnData } = state;
      if (columnData[objectId]) {
        const newColumnData = { ...columnData };
        delete newColumnData[objectId][columnId];
        return {
          ...state,
          columnData: newColumnData,
        };
      }
      return state;
    }
    case GOD_TABLE_FETCH_COLUMN_DATA: {
      const { data } = action;
      const { columnData } = state;
      const newColumnData = { ...columnData };
      each(data, (obj, objId) => {
        if (newColumnData[objId]) {
          newColumnData[objId] = { ...newColumnData[objId], ...obj };
        } else {
          newColumnData[objId] = obj;
        }
      });
      return {
        ...state,
        columnData: newColumnData,
      };
    }
    case GOD_TABLE_REQUEST_EDIT_COLUMN: {
      const { tableId, column } = action;
      return {
        ...state,
        editingColumn: {
          tableId,
          column,
        },
        deletingColumn: {
          tableId: null,
          column: null,
        },
      };
    }
    case GOD_TABLE_REQUEST_DELETE_COLUMN: {
      const { tableId, column } = action;
      return {
        ...state,
        deletingColumn: {
          tableId,
          column,
        },
        editingColumn: {
          tableId: null,
          column: null,
        },
      };
    }
    case GOD_TABLE_REQUEST_RESET_COLUMNS: {
      const { tableId } = action;
      return {
        ...state,
        resetingTableId: tableId,
      };
    }
    case GOD_TABLE_REQUEST_EDIT_CUSTOM_META: {
      const { meta } = action;
      return {
        ...state,
        editingMeta: meta,
      };
    }
    default:
      return state;
  }
};

// Get all posts
export const getTableStates = (state, organizationId, authId, tableId) => {
  const k = `${organizationId}::${authId}::${tableId}`;
  return state.godTables.states[k];
};

export const getColumnData = state => state.godTables.columnData;

export const getEditingColumn = state => state.godTables.editingColumn;
export const getDeletingColumn = state => state.godTables.deletingColumn;
export const getResetingTableId = state => state.godTables.resetingTableId;

export const getEditingMeta = state => state.godTables.editingMeta;


// Export Reducer
export default GodTableReducer;
